import API from "@/api";
import api from "@/api";

const state = {
  selfServiceLogo: 'https://acada-client-logos.s3.eu-west-2.amazonaws.com/acada_black.svg',
  selfServiceAlias: 'Self-Service',
  selfServiceVettingConfig: null,
}
const getters = {
  selfServiceLogo: (state) => state.selfServiceLogo,
  selfServiceAlias: (state) => state.selfServiceAlias,
  selfServiceVettingConfig: (state) => state.selfServiceVettingConfig,
}
const mutations = {
  setSelfServiceLogo(state, payload){
    state.selfServiceLogo = payload;
  },
  setSelfServiceAlias(state, payload){
    state.selfServiceAlias = payload;
  },
  setSelfServiceVettingConfig(state, payload){
    state.selfServiceVettingConfig = payload;
  },
}
const actions = {
  getSelfServiceConfig(context){
    return new Promise((resolve, reject) => {
      API.getSelfServiceConfig()
        .then(({data}) => {
          context.dispatch('setSelfServiceConfig', data)
            .then(() => resolve(data))
            .catch(e => reject(e));
        })
        .catch(e => {
          console.error(e);
          reject(e);
        })
    })
  },
  setSelfServiceConfig(context, payload){
    return new Promise((resolve, reject) => {
      const {
        selfServiceAlias,
        selfServiceLogo,
        selfServiceVettingConfig,
      } = payload;

      if(selfServiceAlias) context.commit('setSelfServiceAlias', selfServiceAlias);
      if(selfServiceLogo) context.commit('setSelfServiceLogo', selfServiceLogo);
      if(selfServiceVettingConfig) context.commit('setSelfServiceVettingConfig', selfServiceVettingConfig);

      resolve()
    })
  },
  createSelfServiceVettingSession(context, payload){
    return new Promise(async (resolve, reject) => {
      try{
        if (Array.isArray(payload.responses)) {
          for (const response of payload.responses) {
            if (response.node) {
              const {id, label, nodeType, nextNode} = response.node;
              response.node = {id, label, nodeType, nextNode};
            }
          }
        }

        const response = await api.createSelfServiceSession(payload)

        let id = payload.id;

        if (
          response &&
          response.data &&
          response.data.createdSession
        ) {
          id = response.data.createdSession.id;
        }

        const { data } = response;

        if (id) {
          resolve(data);
        } else {
          throw new Error('Session id not set');
        }
      } catch (e) {
        console.error(e)
        reject(e)
      }
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
};
